module.exports = __webpack_public_path__ + "static/media/logo-active-network-gray.61f4655d.svg";